import styled from '@emotion/styled';
import { containerStyle } from '../lib/styles';

export const LayoutContainer = styled.div`
  ${containerStyle};
`;
